module.exports = __webpack_public_path__ + "img/logo_poli.fc50d418.png";